import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/access-channel/b2b/mscbook-enhanced/figurehead/src/components/pages/HomePage.tsx");
